import { InformationCircleIcon } from '@heroicons/react/outline'
import { ChartBarIcon } from '@heroicons/react/outline'
import { useState, useEffect } from 'react'
import { Alert } from './components/alerts/Alert'
import { Grid } from './components/grid/Grid'
import { Keyboard } from './components/keyboard/Keyboard'
import { AboutModal } from './components/modals/AboutModal'
import { InfoModal } from './components/modals/InfoModal'
import { StatsModal } from './components/modals/StatsModal'
import { ExtraModal } from './components/modals/ExtraModal'
import { WIN_MESSAGES } from './constants/strings'


import { isWordInWordList, isWinningWord, solution, solutionDefinition, getClosestWord, getWordDef, wordLength } from './lib/words'
import { addStatsForCompletedGame, loadStats } from './lib/stats'
import {
  loadGameStateFromLocalStorage,
  saveGameStateToLocalStorage,
} from './lib/localStorage'

import { CONFIG } from './constants/config'
import ReactGA from 'react-ga'
import '@bcgov/bc-sans/css/BCSans.css'
const ALERT_TIME_MS = 3000

function App() {
    const [currentGuess, setCurrentGuess] = useState<Array<string>>([])

    const [badSpell, setBadSpell] = useState<string>("")
    const [badSpellDef, setBadSpellDef] = useState<string>("")


  const [isGameWon, setIsGameWon] = useState(false)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false)
  const [isNotEnoughLetters, setIsNotEnoughLetters] = useState(false)
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false)
  const [isWordNotFoundAlertOpen, setIsWordNotFoundAlertOpen] = useState(false)
    const [isGameLost, setIsGameLost] = useState(false)

  const [usedLastChance, setLastChance] = useState(false)
    const [isExtraModalOpen, setIsExtraModalOpen] = useState(false)

  const [successAlert, setSuccessAlert] = useState('')
  const [guesses, setGuesses] = useState<string[][]>(() => {
    const loaded = loadGameStateFromLocalStorage()
    if (loaded?.solution !== solution) {
      return []
    }
    const gameWasWon = loaded.guesses
      .map((guess) => guess.join(''))
      .includes(solution)
    if (gameWasWon) {
      setIsGameWon(true)
    }
    if (loaded.guesses.length === 6 && !gameWasWon) {
      setIsGameLost(true)
    }
    return loaded.guesses
  })

  const TRACKING_ID = CONFIG.googleAnalytics // YOUR_OWN_TRACKING_ID

  if (TRACKING_ID && process.env.NODE_ENV !== 'test') {
    ReactGA.initialize(TRACKING_ID)
    ReactGA.pageview(window.location.pathname)
  }
  const [stats, setStats] = useState(() => loadStats())

  useEffect(() => {
    saveGameStateToLocalStorage({ guesses, solution })
  }, [guesses])

  useEffect(() => {
    if (isGameWon) {
      setSuccessAlert(
        WIN_MESSAGES[Math.floor(Math.random() * WIN_MESSAGES.length)]
      )
      setTimeout(() => {
        setSuccessAlert('')
        setIsStatsModalOpen(true)
      }, ALERT_TIME_MS)
    }
    if (isGameLost) {
      setTimeout(() => {
        setIsStatsModalOpen(true)
      }, ALERT_TIME_MS)
    }
  }, [isGameWon, isGameLost])

  const onChar = (value: string) => {
    if (
      //currentGuess.length < CONFIG.wordLength &&
        currentGuess.length < wordLength &&
      guesses.length < CONFIG.tries &&
      !isGameWon
    ) {
      let newGuess = currentGuess.concat([value])
      setCurrentGuess(newGuess)
    }
  }

  const onDelete = () => {
    setCurrentGuess(currentGuess.slice(0, -1))
  }

  const onEnter = () => {
    if (isGameWon || isGameLost) {
      return
    }
    if (!(currentGuess.length === wordLength)) {
      setIsNotEnoughLetters(true)
      return setTimeout(() => {
        setIsNotEnoughLetters(false)
      }, ALERT_TIME_MS)
    }

      if (!isWordInWordList(currentGuess.join(''))) {
          var badString = getClosestWord(currentGuess.join(''))
          setBadSpell(badString)
          setBadSpellDef(getWordDef(badString))
      setIsWordNotFoundAlertOpen(true)
      return setTimeout(() => {
        setIsWordNotFoundAlertOpen(false)
      }, ALERT_TIME_MS)
    }
    const winningWord = isWinningWord(currentGuess.join(''))

    if (
      currentGuess.length === wordLength &&
      guesses.length < CONFIG.tries &&
      !isGameWon
    ) {
      setGuesses([...guesses, currentGuess])
      setCurrentGuess([])

      if (winningWord) {
        setStats(addStatsForCompletedGame(stats, guesses.length))
        return setIsGameWon(true)
      }

        if (guesses.length === CONFIG.tries - 1 && !usedLastChance) {
            setIsExtraModalOpen(true)
        }
        else if (guesses.length === CONFIG.tries - 1) {
            setStats(addStatsForCompletedGame(stats, guesses.length + 1))
            setIsGameLost(true)
        }

    }
  }
    //Not Wordle - {CONFIG.language}
  return (
    <div className="py-8 max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div className="flex w-80 mx-auto items-center mb-8">
        <div className="w-0" > </div>
        <h1 className="text-xl centered grow font-bold">
          {CONFIG.language} Wakon
        </h1>
        <InformationCircleIcon
            className="h-6 w-6 cursor-pointer "
                  style={{  marginLeft: '2pt', marginRight: '1pt'}}
          onClick={() => setIsInfoModalOpen(true)}
        />
        <ChartBarIcon
            className="h-6 w-6 cursor-pointer"
            style={{ marginLeft: '2pt', marginRight: '2pt' }}
          onClick={() => setIsStatsModalOpen(true)}
        />
        <img src={require("./wlccIcon.png")} alt="WLCC" style={{ marginLeft: '2pt', marginRight: '0pt' }} className="h-6 w-6 cursor-pointer" onClick={() => window.open("https://www.maliseet.org/", "_blank")}/>
      </div>
      <Grid guesses={guesses} currentGuess={currentGuess} />
      <Keyboard
        onChar={onChar}
        onDelete={onDelete}
        onEnter={onEnter}
        guesses={guesses}
      />
      <InfoModal
        isOpen={isInfoModalOpen}
        handleClose={() => setIsInfoModalOpen(false)}
          />
          <ExtraModal
              isOpen={isExtraModalOpen}
              handleClose={() => { setIsExtraModalOpen(false); setLastChance(true); setIsGameLost(true);}}
              setOption={() => { guesses.pop(); setIsExtraModalOpen(false); setLastChance(true); }}
        />
      <StatsModal
        isOpen={isStatsModalOpen}
        handleClose={() => setIsStatsModalOpen(false)}
        guesses={guesses}
        gameStats={stats}
        isGameLost={isGameLost}
        isGameWon={isGameWon}
        handleShare={() => {
          setSuccessAlert('Game copied to clipboard')
          return setTimeout(() => setSuccessAlert(''), ALERT_TIME_MS)
        }}
      />
      <AboutModal
        isOpen={isAboutModalOpen}
        handleClose={() => setIsAboutModalOpen(false)}
      />

      <button
        type="button"
        className="mx-auto mt-8 flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 select-none"
        onClick={() => setIsAboutModalOpen(true)}
      >
        About this game
      </button>

    
    <Alert message="Not enough letters" isOpen={isNotEnoughLetters} variant="spell" />
    <Alert message={`Close Guess...\nDid you mean ${badSpell}?\nThis means: \"${badSpellDef}\"`} isOpen={isWordNotFoundAlertOpen} variant="spell"/>
      <Alert message={
                `The word was ${solution}.
                This means \"${solutionDefinition}\"`}
              isOpen={isGameLost} />
      <Alert
        message={`Kwoli Kiseht!\nThe word was ${solution}.\n
            This means: ${solutionDefinition}`}
        isOpen={isGameWon}
        variant="success"
          />
        <Alert message={
              `Hint: Today's word means \"${solutionDefinition}\"`}
              isOpen={!isGameLost && !isGameWon && usedLastChance}
              variant="last"
          />
          
      </div>

  )
}



export default App
